export const navigateAndReturn = (name, page, returnLocation) => {

    if(returnLocation) {
        sessionStorage.setItem(name, returnLocation)
    }

    return page;
}